import theme from '@/styles/theme';
import { transparentize } from 'polished';
import styled from 'styled-components';

export const ClickableIconStyle = styled.div<{
  $baseColor?: keyof typeof theme.colors;
  $baseColorTransparency?: number;
}>`
  cursor: pointer;
  padding: 5px;
  border-radius: ${({ theme }) => theme.radius.md};

  display: flex;
  align-items: center;

  &:hover {
    background: ${({ theme, $baseColor, $baseColorTransparency }) =>
      transparentize(
        $baseColorTransparency ?? 0,
        theme.colors[$baseColor ?? 'gray5'],
      )};
  }
`;
